import { ApiBaseServiceProvider } from './ApiBaseServiceProvider';
import axios from 'axios';
import {
  DraftsGetAllFilters,
  GetDraftArticleResponse,
  GetDraftArticlesResponse,
  GetDraftsCountResponse,
} from '@/@types/responses/DraftArticlesResponses';
import { Article } from '@/models/article/Article';
import { SaveOptions } from '@/@types/SaveOptions';

export class DraftArticleServiceProvider extends ApiBaseServiceProvider {
  scope = 'draft';

  get = (id: string) => {
    return axios.get<GetDraftArticleResponse>(this.getBaseUrl() + id, this.getRequestConfig());
  };

  getAll = (filters: DraftsGetAllFilters) => {
    const params = new URLSearchParams();
    params.append('page', filters.page.toString());
    if (filters.q) params.append('q', filters.q);
    if (filters.author) params.append('author', filters.author);
    if (filters.workspace) params.append('workspace', filters.workspace);
    if (filters.type) params.append('type', filters.type);
    if (filters.filters) params.append('filters', filters.filters ? '1' : '0');
    if (filters.sortOrder) params.append('sortOrder', filters.sortOrder);

    const url = `${this.getBaseUrl()}?${params.toString()}`;
    return axios.get<GetDraftArticlesResponse>(url, this.getRequestConfig());
  };

  count = () => {
    return axios.get<GetDraftsCountResponse>(this.getBaseUrl() + 'count', this.getRequestConfig());
  };

  save = (article: Article, options: SaveOptions) => {
    const { updatedByUser, isPublish = false, isRestore = false, isNotification = false } = options;

    return axios.post<{ article: any }>(
      this.getBaseUrl('article') + article.id + '/draft',
      Object.assign({}, article, { updatedByUser, isPublish, isNotification, isRestore }),
      this.getRequestConfig()
    );
  };

  delete = (id: string) => {
    return axios.delete(this.getBaseUrl() + id, this.getRequestConfig());
  };

  getDiscardHash = (id: string) => {
    return axios.get<{ hash: string }>(this.getBaseUrl() + id + '/discard-hash', this.getRequestConfig());
  };

  discard = (id: string) => {
    return axios.post(this.getBaseUrl() + id + '/discard', {}, this.getRequestConfig());
  };
}
